import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";

//Redux
import { useDispatch } from "react-redux";
import {
  getTodaysData,
  isValidNumber,
  validateContactNumber,
  validateName,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import TermsConditions from "./TermsConditions";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const EquipmentModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  // View attachment files
  /* pop failure modal data*/
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [agreed, setAgreed] = useState(false);
  const handleAgreement = (e) => {
    setAgreed(e.target.checked);
  };

  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);

  const showAddProduct = () => {
    setModalShowAddProduct(true);
  };

  const hideModal = () => {
    setModalShowAddProduct(false);
  };

  const [getFailureFuelEntry] = useState(FailureFuelEntry);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);

  const [formInputs, setFormInputs] = useState({
    filledDate: getTodaysData() || "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    liters: "",
    price: "",
    totalAmount: "",
    paymentMode: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  });

  //Validations
  const [validation, setValidation] = useState({
    filledDate: "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    paymentMode: "",
    liters: "",
    price: "",
    odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    totalAmount: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  });

  const handleInputChange = ({ target: { name, value } }) => {
    // Real-time validation
    let error = "";
    switch (name) {
      case "truckNo":
        if (!validateRequired(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverName":
        if (!validateName(value)) error = message.VALID_CUSTOMER_NAME;
        break;
      case "liters":
      case "price":
      case "oldReading":
      case "newReading":
      case "km":
        if (!isValidNumber(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverContactNr":
        if (!validateContactNumber(value)) error = message.VALID_CONTACT_NUMBER;
        break;
      default:
        break;
    }

    // Update form input values
    setFormInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      if (updatedInputs.liters && updatedInputs.price) {
        updatedInputs.totalAmount =
          Number(updatedInputs.liters) * Number(updatedInputs.price);
      } else {
        updatedInputs.totalAmount = "";
      }

      if (updatedInputs.oldReading && updatedInputs.newReading) {
        updatedInputs.usageReading =
          Number(updatedInputs.newReading) - Number(updatedInputs.oldReading);
      } else {
        updatedInputs.usageReading = "";
      }

      if (updatedInputs.usageReading && updatedInputs.liters) {
        updatedInputs.mileage =
          Number(updatedInputs.usageReading) / Number(updatedInputs.liters);
      } else {
        updatedInputs.mileage = "";
      }

      return updatedInputs;
    });

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    paymentMode: "",
    liters: "",
    price: "",
    totalAmount: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.truckNo)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        truckNo: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.driverName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.driverName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateContactNumber(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.price)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        price: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.price)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        price: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!isValidNumber(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.km)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        km: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.km)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        km: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    setFormInputs((prev) => ({ ...prev, ...initialState }));

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Equipment Rental
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">EA</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">
                    Equipment Rental Agreement
                  </span>
                  <span className="subHeaderTitle">
                    Customer/Company Rental Information (known as “Renter”)
                  </span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Name"
                            placeholder=""
                            name="companyName"
                            id="companyName"
                            value={formInputs?.companyName || ""}
                            error={validation.companyName || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Full Legal Name"
                            placeholder=""
                            name="legalName"
                            id="legalName"
                            error={validation.legalName || ""}
                            value={formInputs?.legalName || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Address"
                            placeholder=""
                            name="address"
                            id="address"
                            error={validation.address || ""}
                            value={formInputs?.address || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="City"
                            placeholder=""
                            name="city"
                            id="city"
                            error={validation.city || ""}
                            value={formInputs?.city || ""}
                            onChange={handleInputChange}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="State"
                            placeholder=""
                            name="state"
                            id="state"
                            error={validation.state || ""}
                            value={formInputs?.state || ""}
                            onChange={handleInputChange}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Zip"
                            placeholder=""
                            name="zipCode"
                            id="zipCode"
                            value={formInputs?.zipCode || ""}
                            // readOnly={true} // make it read-only since it’s calculated
                            // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Phone"
                            placeholder=""
                            name="phoneNr"
                            id="phoneNr"
                            error={validation.phoneNr || ""}
                            value={formInputs?.phoneNr || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Email"
                            placeholder=""
                            name="email"
                            id="email"
                            error={validation.email || ""}
                            value={formInputs?.email || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <Row className="accordion-button">
              {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
              <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                <span className="iconLogo">TC</span>
              </Col>

              <Col xs={4} md={4} lg={4}>
                <span className="headerTitle">Terms And Conditions</span>
                <span className="subHeaderTitle">Terms And Conditions</span>
              </Col>
            </Row>
          </h2>
          <div>
            <div className="accordion-body">
              <Row>
                <Col xs={12} md={12} lg={12}>
                  <div className="accordion-body commTopButtonRightLeftPadding">
                    <Row className="pt-2 pb-2">
                      <Col xs={4} md={4} lg={4}>
                        <span
                          className="headerTitle"
                          onClick={showAddProduct}
                          style={{
                            cursor: "pointer",
                            color: "#007bff",
                            textDecoration: "underline",
                          }}
                        >
                          Terms And Conditions
                        </span>
                      </Col>
                    </Row>

                    <Row className="pb-3 pt-1">
                      <Col xs={12} md={12} lg={12}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="agreeCheckbox"
                            checked={agreed}
                            onChange={handleAgreement}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="agreeCheckbox"
                          >
                            I agree to the Terms and Conditions
                          </label>
                        </div>
                        {agreed && (
                          <div className="text-success pt-2">✔️ Agreed</div>
                        )}
                        {agreed && (
                          <>
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Renter Sign"
                                  placeholder=""
                                  name="renterSign"
                                  id="renterSign"
                                  value={formInputs?.renterSign || ""}
                                  error={validation.renterSign || ""}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                  // required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="date"
                                  label="Date"
                                  name="filledDate"
                                  id="filledDate"
                                  value={formInputs?.filledDate}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bio-Medical Instruments Inc"
                                  placeholder=""
                                  name="renterSign"
                                  id="renterSign"
                                  value={formInputs?.renterSign || ""}
                                  error={validation.renterSign || ""}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                  // required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="date"
                                  label="Date"
                                  name="filledDate"
                                  id="filledDate"
                                  value={formInputs?.filledDate}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <p className="fw-bold">
                                {" "}
                                PERSONAL GUARANTEE (REQUIRED).
                              </p>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Signature of Guarantor"
                                  placeholder=""
                                  name="signeOfGuarantor"
                                  id="signeOfGuarantor"
                                  value={formInputs?.signeOfGuarantor || ""}
                                  error={validation.signeOfGuarantor || ""}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                  // required={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="date"
                                  label="Date"
                                  name="filledDate"
                                  id="filledDate"
                                  value={formInputs?.filledDate}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Printed Name of Guarantor "
                                  placeholder=""
                                  name="nameOfGuarantor"
                                  id="nameOfGuarantor"
                                  value={formInputs?.nameOfGuarantor || ""}
                                  error={validation.nameOfGuarantor || ""}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                  // required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Social Security #"
                                  placeholder=""
                                  name="socialSecurity"
                                  id="socialSecurity"
                                  value={formInputs?.socialSecurity || ""}
                                  error={validation.socialSecurity || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Credit Card # "
                                  placeholder=""
                                  name="creditCard"
                                  id="creditCard"
                                  value={formInputs?.creditCard || ""}
                                  error={validation.creditCard || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Expires"
                                  placeholder=""
                                  name="expires"
                                  id="expires"
                                  value={formInputs?.expires || ""}
                                  error={validation.expires || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Current Telephone #"
                                  placeholder=""
                                  name="telephoneNr"
                                  id="telephoneNr"
                                  value={formInputs?.telephoneNr || ""}
                                  error={validation.telephoneNr || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Current Telephone #"
                                  placeholder=""
                                  name="telephoneNr"
                                  id="telephoneNr"
                                  value={formInputs?.telephoneNr || ""}
                                  error={validation.telephoneNr || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="State"
                                  placeholder=""
                                  name="currentState"
                                  id="currentState"
                                  value={formInputs?.currentState || ""}
                                  error={validation.currentState || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Zip Code"
                                  placeholder=""
                                  name="currentZipCode"
                                  id="currentZipCode"
                                  value={formInputs?.currentZipCode || ""}
                                  error={validation.currentZipCode || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer ID (Internal use only)"
                                  placeholder=""
                                  name="cID"
                                  id="cID"
                                  value={formInputs?.cID || ""}
                                  error={validation.cID || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        {
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button
                className="btnTable btn-danger"
                onClick={handleCancel}
                disabled={disabled}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mt-2">
              <button
                className="btnTable"
                disabled={disabled}
                onClick={handleSave}
              >
                Save
              </button>
            </Col>
          </Row>
        }

        <TermsConditions show={modalShowAddProduct} onHide={hideModal} />
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureFuelEntry}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EquipmentModal;
